import { log } from 'log';
import { useCallback, useMemo } from 'react';

import * as Types from '../types';
import { useUserSelector } from 'js/store/hooks';
import { path } from 'ramda';
import { htcmdService } from 'js/services/htcmd.service';

export const useRequestXpointNativePacket = ({
    sdk,
    license,
    transactionID
}: {
    sdk: Types.XPointSDKInstance | null;
    license: any;
    transactionID: string | null;
    onError: CallableFunction;
}) => {
    const userId: string = useUserSelector(path(['userDetails', 'userId'])) ?? '';

    const {
        clientId,
        clientBrand,
        jurisdictionAreaId,
        jurisdictionAreaName,
        customData,
        sessionHash
    } = useMemo(() => Object.fromEntries(license?.map(({
        key,
        value
    }: {
        key: string;
        value: string;
    }) => {
        return [key, value];
    }) ?? []), [license]);

    return useCallback(async () => {
        if (!sdk) {
            return;
        }

        log('gcReq', {
            transactionID,
            license
        });

        htcmdService.sendMessage('geofencingrequest', {
            provider: 'xpoint',
            transactionID,
            userId,
            clientId,
            clientBrand,
            jurisdictionAreaId,
            jurisdictionAreaName,
            customData,
            sessionHash
        });
    }, [
        sdk,
        userId,
        clientId,
        clientBrand,
        jurisdictionAreaId,
        jurisdictionAreaName,
        customData,
        sessionHash,
        license,
        transactionID
    ]);
};
